
	<quill-view
	  [content]="sanitizedContent"
	  [preserveWhitespace]="true"
	  [sanitize]="true"
	  format="html"
	></quill-view>
	

  